import tree from './icons/tree'
import fingerbank from './icons/fingerbank'
import grafana from './icons/grafana'

export default {
  ...tree,
  ...fingerbank,
  ...grafana
}